module.exports = __webpack_public_path__ + "img/Logo_Bon_a_Savoir.e672d785.jpg";